/* file description */

/** 文本类型业务组件默认显示长度，超长显示... */
export const TextMaxLength = 30;

/**
 * 规则触发时机
 */
export enum RuleTigger {
  /** 字段变更时触发 */
  FieldChange = 'FieldChange',
  /** 页面数据变更时触发 */
  PageValuesChange = 'PageValuesChange',
  /** 表单提交规则 */
  Submit = 'Submit',
}

// 表格行选择类型
export enum TableRowSelectType {
  /** 多选 */
  Checkbox = 'checkbox',
  /** 单选 */
  Radio = 'radio',
}

/** 行数据主键 */
export const TableRowId = '_id';


export enum AbilityPoint {
  /** 是否可创建 */
  canCreate = 'CAN_CREATE',
  /** 是否可更新 */
  canUpdate = 'CAN_UPDATE',
  /** 是否可删除 */
  canDelete = 'CAN_DELETE',
  /** 是否可导出（列表导出按钮） */
  canExport = 'CAN_EXPORT',
  /** 是否可导入（列表导入按钮） */
  canImport = 'CAN_IMPORT',
  /** 是否可检索（列表查看） */
  canSearch = 'CAN_SEARCH',
  /** 详情是否可查看 */
  canView = 'CAN_VIEW',
}
